import React from "react";
import { connect } from "react-redux";
import { sortMedia } from "util/sorts";
import { List } from "react-toolbox/lib/list";
import ModuleItemsListItem from "manage-modules/components/card/ModuleItemsListItem";
import theme from "manage-modules/components/card/ModuleItemsListTheme.css";

const ModuleItemsList = ({ itemList }) => (
  <div className={theme.listContainer}>
    <List theme={theme}>
      {sortMedia(itemList)
        .map(media => (
          <ModuleItemsListItem key={media.id} media={media} mediaLink />
        ))}
    </List>
  </div>
);

const mapStateToProps = state => ({
  itemList: state.manageModules.moduleCard.items,
});

export default connect(mapStateToProps)(ModuleItemsList);
